import { createMutationHelper } from '@utils/swr'
import { type OtpRequest } from '../../../types/apiRequest'
import { type SendOtpResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['post']['sendOtp'], SendOtpResponse, OtpRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/otp',
  fetcher: (url, { arg, client }) => {
    return client.post(url, arg)
  },
})

export const useRequestSendOtp = useMutation
